import { render, staticRenderFns } from "./numericText.vue?vue&type=template&id=a8260be6&"
import script from "./numericText.vue?vue&type=script&lang=js&"
export * from "./numericText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports